import { render, staticRenderFns } from "./coursEleve.vue?vue&type=template&id=56b87eac&"
import script from "./coursEleve.vue?vue&type=script&lang=js&"
export * from "./coursEleve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports